import { SipSessionEventBus } from 'features/sip/services';
import { VoiceMeetingEventBus } from 'features/voice-meeting/services';

export const handleServiceResets = () => {
  SipSessionEventBus.endCall$.next();
  VoiceMeetingEventBus.resetLocalSession();
};
